"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var _Modal = require("./Modal.styles");

var Instructions = function Instructions(_ref) {
  var children = _ref.children,
      title = _ref.title,
      img = _ref.img,
      className = _ref.className;
  return (0, _jsxRuntime.jsxs)("div", {
    css: [_elements.text.styles.textXs, _Modal.styles.instructions, process.env.NODE_ENV === "production" ? "" : ";label:Instructions;"],
    className: (0, _clsx["default"])('grui pt-10 pb-11 px-9 flex items-start', !img && 'pl-10', className),
    children: [img && (0, _jsxRuntime.jsx)("img", {
      src: img,
      alt: "Instructions",
      className: "grui mr-6"
    }), (0, _jsxRuntime.jsxs)("div", {
      children: [(0, _jsxRuntime.jsx)("h5", {
        className: "grui mb-3",
        css: _elements.heading.styles.h5,
        children: title
      }), children]
    })]
  });
};

Instructions.propTypes = {
  children: _propTypes.node,
  title: _propTypes.node,
  className: _propTypes.string,
  img: _propTypes.string
};
Instructions.defaultProps = {
  children: undefined,
  title: undefined,
  className: undefined,
  img: undefined
};
var _default = Instructions;
exports["default"] = _default;
//# sourceMappingURL=Instructions.js.map